<template>
  <div class="content cash-flow-item-list">
    <div class="form-content">
      <a-row :gutter="16" style="margin-top: 15px">
        <a-col :span="6">
          <CommonSelect
            :isBu="true"
            :list="$store.state.settlementBuList"
            :placeholder="$t('结算组织')"
            :code.sync="formData.businessUnitCode"
            @change="searchHandle(1)"
          />
        </a-col>
        <a-col :span="6">
          <CommonQuerySelect
            :placeholder="$t('现金流量表')"
            :init="true"
            api="getCashFlowTabletist"
            :name.sync="formData.cashFlowTableCodeName"
            :code.sync="formData.cashFlowTableCode"
            @change="searchHandle(1)"
          />
        </a-col>
        <a-col :span="6">
          <a-input
            allow-clear
            v-model.trim="formData.nameOrCode"
            :placeholder="$t('搜索编码/名称')"
            @keydown.enter="getTableList(1)"
          />
        </a-col>
        <a-col :span="6">
          <a-button @click="searchHandle(1)" type="primary">
            <i class="iconfont" style="margin-right: 5px">&#xe647;</i>
            {{ $t(`查询`) }}
          </a-button>
          <a-button @click="showCreateModal" type="primary" style="margin-left: 10px">
            {{ $t(`创建`) }}
          </a-button>
        </a-col>
      </a-row>
    </div>
    <div class="flex">
      <div class="left-content" :style="{ height: scrollHeight + 'px' }">
        <a-tree
          v-if="showTree"
          :tree-data="treeList"
          :selectedKeys.sync="selectedKeys"
          :defaultExpandedKeys="['all']"
          @select="onSelect"
        />
      </div>
      <div class="right-content">
        <CommonTable
          ref="CommonTableRef"
          :columns.sync="columns"
          :loading="loading"
          :dataSource="tableData"
          :total="total"
          rowKey="id"
          :scroll="{
            y: scrollHeight - 110,
          }"
          :showSetting="false"
          @search="getList"
        >
          <template v-slot:code="{ text, record }">
            <a @click="viewDetail(record)">{{ text }}</a>
          </template>
          <template v-slot:action="{ record }">
            <a-button
              type="link"
              size="small"
              @click="showAddChildModal(record)"
              style="padding: 0 8px"
            >
              {{ $t('添加子项目') }}
            </a-button>
            <template v-if="editingId === record.id">
              <a-button
                type="link"
                size="small"
                @click="handleSaveInline(record)"
                style="padding: 0 8px"
              >
                {{ $t('保存') }}
              </a-button>
              <a-button type="link" size="small" @click="handleCancelInline" style="padding: 0 8px">
                {{ $t('取消') }}
              </a-button>
            </template>
            <template v-else>
              <a-button
                type="link"
                size="small"
                @click="startInlineEdit(record)"
                style="padding: 0 8px"
                :disabled="Boolean(+record.isPreset)"
              >
                {{ $t('快速编辑') }}
              </a-button>
              <a-button
                type="link"
                size="small"
                @click="handleEdit(record)"
                style="padding: 0 8px"
                :disabled="Boolean(+record.isPreset)"
              >
                {{ $t('编辑') }}
              </a-button>
              <a-button
                type="link"
                size="small"
                danger
                @click="handleDelete(record)"
                style="padding: 0 8px"
                :disabled="Boolean(+record.isPreset)"
              >
                {{ $t('删除') }}
              </a-button>
            </template>
          </template>
          <template v-slot:name="{ text, record }">
            <a-input v-if="editingId === record.id" v-model="editingRow.name" size="small" />
            <span v-else>{{ text }}</span>
          </template>
          <template v-slot:status="{ record }">
            <a-switch
              size="small"
              :checked="Boolean(+record.status)"
              :disabled="Boolean(+record.isPreset)"
              @change="(checked) => handleStatusChange(record, checked)"
            />
          </template>
        </CommonTable>
      </div>
    </div>

    <!-- 创建弹窗 -->
    <a-modal
      width="800px"
      :title="
        createForm.id
          ? $t('编辑现金流量项目')
          : isAddChild
          ? $t('添加子项目')
          : $t('创建现金流量项目')
      "
      :visible="createVisible"
      @ok="handleCreate"
      @cancel="handleCreateCancel"
      :confirmLoading="createLoading"
    >
      <a-form-model ref="createFormRef" :model="createForm" :rules="createRules">
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item :label="$t('编码')" prop="code">
              <a-input
                v-if="isAddChild"
                :addon-before="codePrefix"
                v-model.trim="codeSuffix"
                :placeholder="$t('请输入编码')"
              />
              <a-input v-else v-model.trim="createForm.code" :placeholder="$t('请输入编码')" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('名称')" prop="name">
              <a-input v-model="createForm.name" :placeholder="$t('请输入名称')" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item :label="$t('项目类别')" prop="type">
              <a-select v-model="createForm.type" :placeholder="$t('请选择项目类别')">
                <a-select-option
                  v-for="item in $store.state.cash_flow_type"
                  :key="item.code"
                  :value="item.code"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('现金流向')" prop="fundingDirection">
              <a-select v-model="createForm.fundingDirection" :placeholder="$t('请选择现金流向')">
                <a-select-option
                  v-for="item in $store.state.funding_direction"
                  :key="item.code"
                  :value="item.code"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item :label="$t('经营活动')">
              <a-switch v-model="createForm.isOperatingActivities" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('汇率变动')">
              <a-switch v-model="createForm.isExchangeRateFluctuations" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item :label="$t('净利润')">
              <a-switch v-model="createForm.isNetProfit" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('现金流量通知单')">
              <a-switch v-model="createForm.isNotify" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="24">
            <a-form-model-item :label="$t('核算维度')">
              <a-input
                readonly
                :placeholder="$t('请选择核算维度')"
                @click="showDimensionModal"
                :value="dimensionName || undefined"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-modal>

    <a-modal
      width="1000px"
      :title="$t('现金流量项目')"
      :visible="visible"
      :maskClosable="false"
      :footer="null"
      @cancel="visible = false"
    >
      <a-radio-group v-model="modalPageType">
        <a-radio-button value="base">{{ $t('基本信息') }}</a-radio-button>
        <a-radio-button value="dimension">{{ $t('核算维度') }}</a-radio-button>
        <a-radio-button value="account">{{ $t('科目列表') }}</a-radio-button>
      </a-radio-group>

      <div class="mt20">
        <a-row :gutter="16" v-show="modalPageType !== 'base'">
          <a-col :span="12">
            <a-form-model-item :label="$t('编码')">
              <a-input v-model="modalData.code" disabled />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('名称')">
              <a-input v-model="modalData.name" disabled />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="16" v-show="modalPageType === 'base'">
          <a-form-model>
            <a-col :span="12">
              <a-form-model-item :label="$t('编码')">
                <a-input v-model="modalData.code" disabled />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('名称')">
                <a-input v-model="modalData.name" disabled />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('项目类别')">
                <a-input :value="$store.getters.cashFlowTypeMapping[modalData.type]" disabled />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('现金流向')">
                <a-input
                  :value="$store.getters.fundingDirectionMapping[modalData.fundingDirection]"
                  disabled
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('经营活动')">
                <a-switch
                  size="small"
                  :checked="Boolean(+modalData.isOperatingActivities)"
                  disabled
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('汇率变动')">
                <a-switch
                  size="small"
                  :checked="Boolean(+modalData.isExchangeRateFluctuations)"
                  disabled
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('净利润')">
                <a-switch size="small" :checked="Boolean(+modalData.isNetProfit)" disabled />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('现金流量通知单')">
                <a-switch size="small" :checked="Boolean(+modalData.isNotify)" disabled />
              </a-form-model-item>
            </a-col>
          </a-form-model>
        </a-row>
        <CommonTable
          v-show="modalPageType === 'dimension'"
          :columns.sync="dimensionColumns"
          :dataSource="modalData.dimensionList"
          :showSetting="false"
          :showPagination="false"
        ></CommonTable>
        <div v-show="modalPageType === 'account'">
          <div style="margin-bottom: 10px">
            <a-button type="primary" @click="showAddAccountMappingModal">
              {{ $t('新增科目映射') }}
            </a-button>
          </div>
          <CommonTable
            :columns.sync="accountColumns"
            :dataSource="accountList"
            :showSetting="false"
            :showPagination="false"
          >
            <template v-slot:dimensionMappings="{ record }">
              <span>
                {{
                  (record.account_dimension_list || [])
                    .map((d) => d.accounting_dimension_name)
                    .join(' / ')
                }}
              </span>
            </template>
            <template v-slot:action="{ record }">
              <a-button
                type="link"
                size="small"
                @click="handleEditAccountMapping(record)"
                style="padding: 0 8px"
              >
                {{ $t('编辑') }}
              </a-button>
              <a-button
                type="link"
                size="small"
                danger
                @click="handleDeleteAccountMapping(record)"
                style="padding: 0 8px"
              >
                {{ $t('删除') }}
              </a-button>
            </template>
          </CommonTable>
        </div>
      </div>
    </a-modal>

    <!-- 核算维度选择弹窗 -->
    <SelectTableModal
      ref="SelectDimensionModalRef"
      rowKey="value_code"
      api="getAccountDimensionList"
      :selecteds="dimensionSelectedRows"
      :title="$t('核算维度')"
      :columns="dimensionModalColumns"
      :params="{
        businessUnitCode: formData.businessUnitCode,
      }"
      @ok="handleDimensionOk"
    />

    <!-- 新增科目映射弹窗 -->
    <a-modal
      width="800px"
      :title="accountMappingForm.id ? $t('编辑科目映射') : $t('新增科目映射')"
      :visible="accountMappingVisible"
      @ok="handleAccountMappingCreate"
      @cancel="handleAccountMappingCancel"
      :confirmLoading="accountMappingLoading"
    >
      <a-form-model
        ref="accountMappingFormRef"
        :model="accountMappingForm"
        :rules="accountMappingRules"
      >
        <a-row :gutter="16">
          <a-col :span="24">
            <a-form-model-item :label="$t('科目')" prop="accountCode">
              <a-input
                readonly
                :placeholder="$t('请选择科目')"
                @click="showAccountModal"
                :value="accountMappingAccountName || undefined"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="24">
            <a-form-model-item :label="$t('余额方向')" prop="direction">
              <a-select v-model="accountMappingForm.direction" :placeholder="$t('请选择余额方向')">
                <a-select-option
                  v-for="item in $store.state.balance_direction"
                  :key="item.code"
                  :value="item.code"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="24">
            <a-form-model-item :label="$t('核算维度')">
              <a-input
                readonly
                :placeholder="$t('请选择核算维度')"
                @click="showAccountMappingDimensionModal"
                :value="accountMappingDimensionName || undefined"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="24">
            <a-form-model-item :label="$t('反向发生额是否抵减')">
              <a-select
                v-model="accountMappingForm.reverseDirectionDeduct"
                :placeholder="$t('请选择反向发生额是否抵减')"
              >
                <a-select-option :value="1">{{ $t('是') }}</a-select-option>
                <a-select-option :value="0">{{ $t('否') }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-modal>

    <!-- 科目选择弹窗 -->
    <SelectAccountModal
      ref="SelectAccountModalRef"
      :hasSelected="accountMappingSelectedAccount"
      :single="true"
      :params="{ isCashFlowItem: 0 }"
      @ok="handleAccountOk"
    />

    <!-- 科目映射核算维度选择弹窗 -->
    <SelectTableModal
      ref="SelectAccountMappingDimensionModalRef"
      rowKey="value_code"
      api="getAccountDimensionList"
      :selecteds="accountMappingDimensionSelectedRows"
      :title="$t('核算维度')"
      :columns="dimensionModalColumns"
      :params="{
        businessUnitCode: formData.businessUnitCode,
      }"
      @ok="handleAccountMappingDimensionOk"
    />
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import http from '@/service/axios'
import api from '@/service/api'
import { convertKeysToCamelCase, buildTree2 } from '@/common'
import SelectTableModal from '@/component/selectTableModal'
import SelectAccountModal from '@/component/selectAccountModal'
export default {
  name: 'cashFlowItemList',
  components: {
    SelectTableModal,
    SelectAccountModal,
  },
  data() {
    return {
      docType: 'cashFlowItemList',
      formData: {
        parentCode: undefined,
        nameOrCode: undefined,
      },
      tableData: [],
      selectedRowKeys: [],
      selectedRows: [],
      total: 0,
      loading: false,

      columns: [],
      dimensionColumns: [],
      accountColumns: [],
      selectedKeys: [],
      treeList: [],
      showTree: false,
      treeMap: {},

      editingId: null,
      editingRow: {},

      visible: false,

      modalPageType: 'base',
      modalData: {},
      accountList: [],

      // 创建相关
      createVisible: false,
      createLoading: false,
      isAddChild: false,
      codePrefix: '',
      codeSuffix: '',
      rawItemList: [],
      createForm: {
        cashFlowTableCode: '',
        cashFlowTableName: '',
        code: '',
        dimensionCodeList: [],
        fundingDirection: '',
        id: undefined,
        isExchangeRateFluctuations: false,
        isNetProfit: false,
        isNotify: false,
        isOperatingActivities: false,
        level: 1,
        name: '',
        parentCode: '',
        rootCode: '',
        type: '',
      },
      createRules: {
        code: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (this.isAddChild) {
                if (!this.codeSuffix || !this.codeSuffix.trim()) {
                  return callback(new Error(this.$t('请输入编码')))
                }
              } else {
                if (!this.createForm.code || !this.createForm.code.trim()) {
                  return callback(new Error(this.$t('请输入编码')))
                }
              }
              callback()
            },
            trigger: ['blur', 'change'],
          },
        ],
        name: [{ required: true, message: this.$t('请输入名称'), trigger: 'blur' }],
        type: [{ required: true, message: this.$t('请选择项目类别'), trigger: 'change' }],
        fundingDirection: [
          { required: true, message: this.$t('请选择现金流向'), trigger: 'change' },
        ],
      },
      dimensionName: '',
      dimensionSelectedRows: [],

      // 科目映射相关
      accountMappingVisible: false,
      accountMappingLoading: false,
      accountMappingForm: {
        accountCode: '',
        accountName: '',
        cashFlowItemCode: '',
        cashFlowItemName: '',
        dimensionMappings: [],
        direction: '',
        reverseDirectionDeduct: 0,
        id: undefined,
      },
      accountMappingRules: {
        accountCode: [{ required: true, message: this.$t('请选择科目'), trigger: 'change' }],
        direction: [{ required: true, message: this.$t('请选择余额方向'), trigger: 'change' }],
      },
      accountMappingAccountName: '',
      accountMappingSelectedAccount: [],
      accountMappingDimensionName: '',
      accountMappingDimensionSelectedRows: [],
    }
  },
  watch: {
    codeSuffix: {
      handler(val) {
        if (this.isAddChild) {
          const cleanVal = val ? val.replace(/\./g, '') : ''
          if (cleanVal !== val) {
            this.codeSuffix = cleanVal
            return
          }
          this.createForm.code = this.codePrefix + cleanVal
        }
      },
    },
  },
  mounted() {
    this.setColumns()
    this.getTreeList()
  },
  activated() {
    this.searchHandle()
  },
  computed: {
    scrollHeight() {
      return window.innerHeight - 220
    },
    dimensionModalColumns() {
      return [
        {
          title: this.$t('编码'),
          dataIndex: 'value_code',
        },
        {
          title: this.$t('名称'),
          dataIndex: 'name',
        },
        {
          title: this.$t('值来源'),
          dataIndex: 'value_name',
        },
      ]
    },
  },
  methods: {
    ...mapMutations(['addPane']),
    reset() {
      Object.assign(this.$data, this.$options.data.call(this))
      this.setColumns()
      this.searchHandle(1)
    },
    setColumns() {
      this.columns = [
        {
          title: this.$t('编码'),
          dataIndex: 'code',
          width: 120,
          scopedSlots: { customRender: 'code' },
        },
        {
          title: this.$t('名称'),
          dataIndex: 'name',
        },
        {
          title: this.$t('核算维度'),
          dataIndex: 'dimensionList',
          customRender: (text) => {
            return text?.map((item) => item.accountingDimensionName).join('/')
          },
        },
        {
          title: this.$t('项目类别'),
          dataIndex: 'type',
          customRender: (text) => this.$store.getters.cashFlowTypeMapping[text],
        },
        {
          title: this.$t('现金流向'),
          dataIndex: 'fundingDirection',
          customRender: (text) => this.$store.getters.fundingDirectionMapping[text],
        },
        {
          title: this.$t('经营活动'),
          dataIndex: 'isOperatingActivities',
          align: 'center',
          customRender: (text) => (text ? <i class="iconfont icon-check"></i> : ''),
        },
        {
          title: this.$t('汇率变动'),
          dataIndex: 'isExchangeRateFluctuations',
          align: 'center',
          customRender: (text) => (text ? <i class="iconfont icon-check"></i> : ''),
        },
        {
          title: this.$t('净利润'),
          dataIndex: 'isNetProfit',
          align: 'center',
          customRender: (text) => (text ? <i class="iconfont icon-check"></i> : ''),
        },
        {
          title: this.$t('现金流量通知单'),
          dataIndex: 'isNotify',
          align: 'center',
          customRender: (text) => (text ? <i class="iconfont icon-check"></i> : ''),
        },
        // {
        //   title: this.$t('创建组织'),
        //   dataIndex: 'businessUnitName',
        // },
        {
          title: this.$t('使用状态'),
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
        },
        {
          title: this.$t('系统预置'),
          dataIndex: 'isPreset',
          align: 'center',
          customRender: (text) => (text ? <i class="iconfont icon-check"></i> : ''),
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          width: 150,
          align: 'center',
          fixed: 'right',
          scopedSlots: { customRender: 'action' },
        },
      ]

      this.dimensionColumns = [
        {
          title: this.$t('编码'),
          dataIndex: 'accountingDimensionCode',
        },
        {
          title: this.$t('核算维度'),
          dataIndex: 'accountingDimensionName',
        },
      ]

      this.accountColumns = [
        {
          title: this.$t('科目编码'),
          dataIndex: 'account_code',
        },
        {
          title: this.$t('科目名称'),
          dataIndex: 'account_name',
        },
        {
          title: this.$t('余额方向'),
          dataIndex: 'direction',
          customRender: (text) => this.$store.getters.balanceDirectionMapping[text],
        },
        {
          title: this.$t('核算维度'),
          dataIndex: 'dimensionMappings',
          scopedSlots: { customRender: 'dimensionMappings' },
        },
        {
          title: this.$t('反向发生额是否抵减'),
          dataIndex: 'reverse_direction_deduct',
          customRender: (text, record) => {
            const val = record.reverseDirectionDeduct ?? record.reverse_direction_deduct
            return val === 1 ? this.$t('是') : val === 0 ? this.$t('否') : '-'
          },
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          width: 160,
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ]
    },
    searchHandle(pageNo) {
      if (!this.formData.cashFlowTableCode) return
      if (!this.formData.businessUnitCode) return
      this.selectedRows = []
      this.selectedRowKeys = []
      this.$refs.CommonTableRef.queryList(pageNo)
    },
    async getTreeList() {
      let res = await http({
        url: api.getCashFlowItemList,
        type: 'post',
        data: {},
      })
      this.rawItemList = res?.result?.list || []
      const { tree, treeMap } = buildTree2(res.result.list)
      this.treeList = [
        {
          title: this.$t('全部'),
          key: 'all',
          children: tree,
        },
      ]
      this.treeMap = treeMap
      this.showTree = true
    },
    onSelect(selectedKeys) {
      const code = selectedKeys[0]
      this.formData.nameOrCode = undefined
      this.formData.parentCode = undefined
      if (selectedKeys.length) {
        if (code === 'all') {
          this.formData.parentCode = undefined
        } else if (this.treeMap[code].children.length > 0) {
          this.formData.parentCode = code
        } else {
          this.formData.nameOrCode = code
        }
      }
      this.searchHandle(1)
    },
    async getList(params) {
      this.loading = true
      await http({
        url: api.getCashFlowItemList,
        data: {
          ...this.formData,
          ...params,
        },
        success: (res) => {
          let result = convertKeysToCamelCase(res.result)
          this.tableData = result.list
          this.total = res.result.total
        },
      })
      this.loading = false
    },
    viewDetail(record) {
      this.visible = true
      this.modalData = record
      this.getCashFlowItemAccountMappingList()
    },
    getCashFlowItemAccountMappingList() {
      http({
        url: api.getCashFlowItemAccountMappingList,
        data: {
          cashFlowTableCode: this.modalData.cashFlowTableCode,
          nameOrCode: this.modalData.code,
        },
        success: (res) => {
          this.accountList = res.result.list
        },
      })
    },
    // 创建相关方法
    showCreateModal() {
      this.createVisible = true
      this.resetCreateForm()
    },
    resetCreateForm() {
      this.isAddChild = false
      this.codePrefix = ''
      this.codeSuffix = ''
      this.createForm = {
        cashFlowTableCode: '',
        cashFlowTableName: '',
        code: '',
        dimensionCodeList: [],
        fundingDirection: '',
        id: undefined,
        isExchangeRateFluctuations: false,
        isNetProfit: false,
        isNotify: false,
        isOperatingActivities: false,
        level: 1,
        name: '',
        parentCode: '',
        rootCode: '',
        type: '',
      }
      this.dimensionName = ''
      this.dimensionSelectedRows = []
      if (this.$refs.createFormRef) {
        this.$refs.createFormRef.clearValidate()
      }
    },
    handleCreateCancel() {
      this.createVisible = false
      this.resetCreateForm()
    },
    async handleCreate() {
      if (this.isAddChild) {
        this.createForm.code = this.codePrefix + (this.codeSuffix ? this.codeSuffix.trim() : '')
      }
      this.$refs.createFormRef.validate(async (valid) => {
        if (!valid) {
          return false
        }
        this.createLoading = true
        const params = {
          cashFlowTableCode:
            this.createForm.cashFlowTableCode || this.formData.cashFlowTableCode || '',
          cashFlowTableName:
            this.createForm.cashFlowTableName || this.formData.cashFlowTableCodeName || '',
          code: this.createForm.code,
          dimensionCodeList: this.createForm.dimensionCodeList,
          fundingDirection: this.createForm.fundingDirection,
          id: this.createForm.id,
          isExchangeRateFluctuations: this.createForm.isExchangeRateFluctuations ? 1 : 0,
          isNetProfit: this.createForm.isNetProfit ? 1 : 0,
          isNotify: this.createForm.isNotify ? 1 : 0,
          isOperatingActivities: this.createForm.isOperatingActivities ? 1 : 0,
          level: this.createForm.level,
          name: this.createForm.name,
          parentCode: this.createForm.parentCode || '',
          rootCode: this.createForm.rootCode || '',
          type: this.createForm.type,
        }
        await http({
          url: api.createOrUpdateCashFlowItem,
          data: params,
          success: () => {
            this.$message.success(this.$t('保存成功'))
            this.createVisible = false
            this.resetCreateForm()
            this.searchHandle()
            this.getTreeList()
          },
        })
        this.createLoading = false
      })
    },
    showDimensionModal() {
      if (!this.formData.businessUnitCode) {
        this.$message.warning(this.$t('请先选择结算组织'))
        return
      }
      this.$refs.SelectDimensionModalRef.open()
    },
    handleDimensionOk(list) {
      this.dimensionSelectedRows = list
      this.createForm.dimensionCodeList = list.map((item) => item.code)
      this.dimensionName = list.map((item) => item.name).join(';')
    },
    // 快速编辑
    startInlineEdit(record) {
      this.editingId = record.id
      this.editingRow = { ...record }
    },
    // 编辑
    handleEdit(record) {
      this.resetCreateForm()
      this.createVisible = true
      this.isAddChild = false
      this.createForm = {
        ...record,
        isExchangeRateFluctuations: !!+record.isExchangeRateFluctuations,
        isNetProfit: !!+record.isNetProfit,
        isNotify: !!+record.isNotify,
        isOperatingActivities: !!+record.isOperatingActivities,
        dimensionCodeList: record.dimensionList?.map((item) => item.accountingDimensionCode) || [],
      }
      this.dimensionSelectedRows =
        record.dimensionList?.map((item) => ({
          value_code: item.accountingDimensionCode,
          name: item.accountingDimensionName,
          code: item.accountingDimensionCode,
        })) || []
      this.dimensionName = this.dimensionSelectedRows.map((item) => item.name).join(';')
      if (this.$refs.createFormRef) {
        this.$refs.createFormRef.clearValidate()
      }
    },
    async handleSaveInline(record) {
      const params = {
        ...record,
        ...this.editingRow,
        isExchangeRateFluctuations: this.editingRow.isExchangeRateFluctuations ? 1 : 0,
        isNetProfit: this.editingRow.isNetProfit ? 1 : 0,
        isNotify: this.editingRow.isNotify ? 1 : 0,
        isOperatingActivities: this.editingRow.isOperatingActivities ? 1 : 0,
        dimensionCodeList: record.dimensionList?.map((item) => item.accountingDimensionCode) || [],
      }
      await http({
        url: api.createOrUpdateCashFlowItem,
        data: params,
        success: () => {
          this.$message.success(this.$t('保存成功'))
          this.editingId = null
          this.searchHandle()
        },
      })
    },
    handleCancelInline() {
      this.editingId = null
      this.editingRow = {}
    },
    async handleStatusChange(record, checked) {
      const params = {
        ...record,
        status: checked ? 1 : 0,
        isExchangeRateFluctuations: record.isExchangeRateFluctuations ? 1 : 0,
        isNetProfit: record.isNetProfit ? 1 : 0,
        isNotify: record.isNotify ? 1 : 0,
        isOperatingActivities: record.isOperatingActivities ? 1 : 0,
        dimensionCodeList: record.dimensionList?.map((item) => item.accountingDimensionCode) || [],
      }
      await http({
        url: api.createOrUpdateCashFlowItem,
        data: params,
        success: () => {
          this.$message.success(this.$t('状态更新成功'))
          this.searchHandle()
        },
      })
    },
    // 获取根节点code
    getRootCode(record, depth = 0) {
      if (!record) return ''
      const rootCode = record.root_code || record.rootCode
      if (rootCode) return rootCode
      const parentCode = record.parent_code || record.parentCode
      if (!parentCode || depth > 10) {
        return record.code
      }
      const parent = this.tableData.find((item) => item.code === parentCode)
      if (!parent) {
        return record.code
      }
      return this.getRootCode(parent, depth + 1)
    },
    // 获取直属子项目自增编码后缀（例如 01, 02）
    getNextChildSuffix(parentCode, cashFlowTableCode) {
      const prefix = parentCode + '.'
      const childCodes = new Set()

      // 1. 从 treeMap 获取直属子节点
      if (
        this.treeMap &&
        this.treeMap[parentCode] &&
        Array.isArray(this.treeMap[parentCode].children)
      ) {
        this.treeMap[parentCode].children.forEach((child) => {
          if (child.key) childCodes.add(child.key)
        })
      }

      // 2. 从 rawItemList 获取直属子节点
      if (Array.isArray(this.rawItemList)) {
        this.rawItemList.forEach((item) => {
          const itemTableCode = item.cash_flow_table_code || item.cashFlowTableCode
          if (cashFlowTableCode && itemTableCode && itemTableCode !== cashFlowTableCode) {
            return
          }
          const pCode = item.parent_code || item.parentCode
          if (pCode === parentCode && item.code) {
            childCodes.add(item.code)
          } else if (item.code && item.code.startsWith(prefix)) {
            const rest = item.code.slice(prefix.length)
            if (rest && !rest.includes('.')) {
              childCodes.add(item.code)
            }
          }
        })
      }

      // 3. 从 tableData 获取直属子节点
      if (Array.isArray(this.tableData)) {
        this.tableData.forEach((item) => {
          const itemTableCode = item.cash_flow_table_code || item.cashFlowTableCode
          if (cashFlowTableCode && itemTableCode && itemTableCode !== cashFlowTableCode) {
            return
          }
          const pCode = item.parent_code || item.parentCode
          if (pCode === parentCode && item.code) {
            childCodes.add(item.code)
          } else if (item.code && item.code.startsWith(prefix)) {
            const rest = item.code.slice(prefix.length)
            if (rest && !rest.includes('.')) {
              childCodes.add(item.code)
            }
          }
        })
      }

      // 提取子编码末尾纯数字并计算最大值
      let maxNum = 0
      childCodes.forEach((code) => {
        if (code.startsWith(prefix)) {
          const suffixStr = code.slice(prefix.length)
          if (/^\d+$/.test(suffixStr)) {
            const num = parseInt(suffixStr, 10)
            if (!isNaN(num) && num > maxNum) {
              maxNum = num
            }
          }
        }
      })

      const nextNum = maxNum + 1
      return String(nextNum).padStart(2, '0')
    },
    // 添加子项目
    showAddChildModal(record) {
      this.resetCreateForm()
      this.isAddChild = true
      const rootCode = this.getRootCode(record)
      const parentCode = record.code || ''
      const cashFlowTableCode = record.cashFlowTableCode || this.formData.cashFlowTableCode || ''
      this.codePrefix = parentCode ? `${parentCode}.` : ''
      this.codeSuffix = this.getNextChildSuffix(parentCode, cashFlowTableCode)
      this.createForm.code = this.codePrefix + this.codeSuffix
      this.createForm.parentCode = parentCode
      this.createForm.level = (record.level || 1) + 1
      this.createForm.rootCode = rootCode
      this.createForm.cashFlowTableCode = cashFlowTableCode
      this.createForm.cashFlowTableName =
        record.cashFlowTableName || this.formData.cashFlowTableCodeName || ''
      this.createForm.type = record.type || ''
      this.createForm.fundingDirection = record.fundingDirection || ''
      this.createForm.isOperatingActivities = !!+record.isOperatingActivities
      this.createForm.isExchangeRateFluctuations = !!+record.isExchangeRateFluctuations
      this.createForm.isNetProfit = !!+record.isNetProfit
      this.createForm.isNotify = !!+record.isNotify
      this.createVisible = true
      if (this.$refs.createFormRef) {
        this.$refs.createFormRef.clearValidate()
      }
    },
    // 删除
    handleDelete(record) {
      this.$confirm({
        title: this.$t('确认删除'),
        content: this.$t('确定要删除该项目吗？'),
        onOk: async () => {
          await http({
            url: api.deleteCashFlowItem,
            data: {
              id: record.id,
            },
            success: () => {
              this.$message.success(this.$t('删除成功'))
              this.searchHandle()
              this.getTreeList()
            },
          })
        },
      })
    },
    // 科目映射相关方法
    showAddAccountMappingModal() {
      this.accountMappingVisible = true
      this.resetAccountMappingForm()
    },
    resetAccountMappingForm() {
      this.accountMappingForm = {
        accountCode: '',
        accountName: '',
        cashFlowItemCode: this.modalData.code || '',
        cashFlowItemName: this.modalData.name || '',
        dimensionMappings: [],
        direction: '',
        reverseDirectionDeduct: 0,
        id: undefined,
      }
      this.accountMappingAccountName = ''
      this.accountMappingSelectedAccount = []
      this.accountMappingDimensionName = ''
      this.accountMappingDimensionSelectedRows = []
      if (this.$refs.accountMappingFormRef) {
        this.$refs.accountMappingFormRef.clearValidate()
      }
    },
    handleAccountMappingCancel() {
      this.accountMappingVisible = false
      this.resetAccountMappingForm()
    },
    showAccountModal() {
      if (!this.formData.businessUnitCode) {
        this.$message.warning(this.$t('请先选择结算组织'))
        return
      }
      // 单选模式，清空已选中的项
      this.accountMappingSelectedAccount = []
      this.$refs.SelectAccountModalRef.open({ isCashFlowItem: 0 })
    },
    handleAccountOk(list) {
      if (list && list.length > 0) {
        // 单选模式，取第一个（组件已确保只返回一个）
        const account = list[0]
        this.accountMappingForm.accountCode = account.code
        this.accountMappingForm.accountName = account.full_name || account.name
        this.accountMappingAccountName = account.full_name || account.name
        this.accountMappingSelectedAccount = [account]
      }
    },
    showAccountMappingDimensionModal() {
      if (!this.formData.businessUnitCode) {
        this.$message.warning(this.$t('请先选择结算组织'))
        return
      }
      this.$refs.SelectAccountMappingDimensionModalRef.open()
    },
    handleAccountMappingDimensionOk(list) {
      this.accountMappingDimensionSelectedRows = list
      this.accountMappingForm.dimensionMappings = list.map((item) => ({
        accountingDimensionCode: item.code,
        accountingDimensionName: item.name,
        accountingDimensionSourceTable: item.item_type || '',
        accountingDimensionValueCode: item.value_code || '',
        accountingDimensionValueName: item.value_name || '',
      }))
      this.accountMappingDimensionName = list.map((item) => item.name).join(';')
    },
    async handleAccountMappingCreate() {
      this.$refs.accountMappingFormRef.validate(async (valid) => {
        if (!valid) {
          return false
        }
        this.accountMappingLoading = true
        const params = {
          accountCode: this.accountMappingForm.accountCode,
          accountName: this.accountMappingForm.accountName,
          cashFlowItemCode: this.accountMappingForm.cashFlowItemCode,
          cashFlowItemName: this.accountMappingForm.cashFlowItemName,
          dimensionMappings: this.accountMappingForm.dimensionMappings,
          direction: this.accountMappingForm.direction,
          reverseDirectionDeduct: this.accountMappingForm.reverseDirectionDeduct,
          id: this.accountMappingForm.id || undefined,
        }
        await http({
          url: api.createOrUpdateCashFlowItemAccountMapping,
          data: params,
          success: () => {
            this.$message.success(this.$t('保存成功'))
            this.accountMappingVisible = false
            this.resetAccountMappingForm()
            this.getCashFlowItemAccountMappingList()
          },
        })
        this.accountMappingLoading = false
      })
    },
    // 编辑科目映射
    handleEditAccountMapping(record) {
      this.accountMappingVisible = true
      // account_dimension_list 是下划线格式的维度列表
      const dimList = record.account_dimension_list || []
      this.accountMappingForm = {
        accountCode: record.account_code,
        accountName: record.account_name,
        cashFlowItemCode: this.modalData.code,
        cashFlowItemName: this.modalData.name,
        dimensionMappings: dimList.map((item) => ({
          accountingDimensionCode: item.accounting_dimension_code,
          accountingDimensionName: item.accounting_dimension_name,
          accountingDimensionSourceTable: item.accounting_dimension_source_table || '',
          accountingDimensionValueCode: item.accounting_dimension_value_code || '',
          accountingDimensionValueName: item.accounting_dimension_value_name || '',
        })),
        direction: record.direction,
        reverseDirectionDeduct:
          record.reverse_direction_deduct !== undefined
            ? record.reverse_direction_deduct
            : record.reverseDirectionDeduct !== undefined
            ? record.reverseDirectionDeduct
            : 0,
        id: record.id,
      }
      this.accountMappingAccountName = record.account_name
      this.accountMappingSelectedAccount = [
        {
          code: record.account_code,
          name: record.account_name,
        },
      ]
      this.accountMappingDimensionSelectedRows = dimList.map((item) => ({
        code: item.accounting_dimension_code,
        name: item.accounting_dimension_name,
        value_code: item.accounting_dimension_value_code || '',
        value_name: item.accounting_dimension_value_name || '',
        item_type: item.accounting_dimension_source_table || '',
      }))
      this.accountMappingDimensionName = this.accountMappingDimensionSelectedRows
        .map((item) => item.name)
        .join(';')
      if (this.$refs.accountMappingFormRef) {
        this.$refs.accountMappingFormRef.clearValidate()
      }
    },
    // 删除科目映射
    handleDeleteAccountMapping(record) {
      this.$confirm({
        title: this.$t('确认删除'),
        content: this.$t('确定要删除该科目映射吗？'),
        onOk: async () => {
          await http({
            url: api.deleteCashFlowItemAccountMapping,
            data: {
              id: record.id,
            },
            success: () => {
              this.$message.success(this.$t('删除成功'))
              this.getCashFlowItemAccountMappingList()
            },
          })
        },
      })
    },
  },
}
</script>

<style scoped lang="scss">
.left-content {
  width: 300px;
  overflow: auto;
}
.right-content {
  flex: 1;
}
.icon-check {
  color: green;
  font-size: 20px;
  font-weight: bold;
}
</style>
